// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body.active-modal {
  overflow-y: hidden;
}

.btn-modal {
  padding: 10px 20px;
  display: block;
  margin: 100px auto 0;
  font-size: 18px;
}

.modal, .overlay {
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  overflow: scroll;
}

.overlay {
  background: rgba(49,49,49,0.8);
}
.modal-content {
  position: absolute;
  top: 15%;
  left: 50%;
  margin: 10px;
  line-height: 1;
  background: #8c8c8c;
  padding: 4px 4px;
  border-radius: 1px;
  max-width: 800px;
  min-width: 300px;
  image-resolution: from-image;
  margin-left:-400px;
}




.button-50 {
position: absolute;
top: 10px;
right: 10px;
padding: 5px 7px;

appearance: button;
background-color: #000;
background-image: none;
border: 1px solid #000;
border-radius: 4px;
box-shadow: #fff 4px 4px 0 0,#000 4px 4px 0 1px;
box-sizing: border-box;
color: #fff;
cursor: pointer;
display: inline-block;
font-family: ITCAvantGardeStd-Bk,Arial,sans-serif;
font-size: 14px;
font-weight: 400;
line-height: 10px;
margin: 0 5px 10px 0;
overflow: visible;
width: 20px;
text-align: center;
text-transform: none;
touch-action: manipulation;
user-select: none;
-webkit-user-select: none;
vertical-align: middle;
white-space: nowrap;
}

.button-50:focus {
text-decoration: none;
}

.button-50:hover {
text-decoration: none;
}

.button-50:active {
box-shadow: rgba(0, 0, 0, .125) 0 3px 5px inset;
outline: 0;
}

.button-50:not([disabled]):active {
box-shadow: #fff 2px 2px 0 0, #000 2px 2px 0 1px;
transform: translate(2px, 2px);
}

@media (min-width: 768px) {
.button-50 {
  padding: 12px 50px;
}
}


`, "",{"version":3,"sources":["webpack://./src/components/Gallery/Modal.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;;;;AAKA;AACA,kBAAkB;AAClB,SAAS;AACT,WAAW;AACX,gBAAgB;;AAEhB,kBAAkB;AAClB,sBAAsB;AACtB,sBAAsB;AACtB,sBAAsB;AACtB,kBAAkB;AAClB,+CAA+C;AAC/C,sBAAsB;AACtB,WAAW;AACX,eAAe;AACf,qBAAqB;AACrB,iDAAiD;AACjD,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,oBAAoB;AACpB,iBAAiB;AACjB,WAAW;AACX,kBAAkB;AAClB,oBAAoB;AACpB,0BAA0B;AAC1B,iBAAiB;AACjB,yBAAyB;AACzB,sBAAsB;AACtB,mBAAmB;AACnB;;AAEA;AACA,qBAAqB;AACrB;;AAEA;AACA,qBAAqB;AACrB;;AAEA;AACA,+CAA+C;AAC/C,UAAU;AACV;;AAEA;AACA,gDAAgD;AAChD,8BAA8B;AAC9B;;AAEA;AACA;EACE,kBAAkB;AACpB;AACA","sourcesContent":["body.active-modal {\n  overflow-y: hidden;\n}\n\n.btn-modal {\n  padding: 10px 20px;\n  display: block;\n  margin: 100px auto 0;\n  font-size: 18px;\n}\n\n.modal, .overlay {\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  position: fixed;\n  overflow: scroll;\n}\n\n.overlay {\n  background: rgba(49,49,49,0.8);\n}\n.modal-content {\n  position: absolute;\n  top: 15%;\n  left: 50%;\n  margin: 10px;\n  line-height: 1;\n  background: #8c8c8c;\n  padding: 4px 4px;\n  border-radius: 1px;\n  max-width: 800px;\n  min-width: 300px;\n  image-resolution: from-image;\n  margin-left:-400px;\n}\n\n\n\n\n.button-50 {\nposition: absolute;\ntop: 10px;\nright: 10px;\npadding: 5px 7px;\n\nappearance: button;\nbackground-color: #000;\nbackground-image: none;\nborder: 1px solid #000;\nborder-radius: 4px;\nbox-shadow: #fff 4px 4px 0 0,#000 4px 4px 0 1px;\nbox-sizing: border-box;\ncolor: #fff;\ncursor: pointer;\ndisplay: inline-block;\nfont-family: ITCAvantGardeStd-Bk,Arial,sans-serif;\nfont-size: 14px;\nfont-weight: 400;\nline-height: 10px;\nmargin: 0 5px 10px 0;\noverflow: visible;\nwidth: 20px;\ntext-align: center;\ntext-transform: none;\ntouch-action: manipulation;\nuser-select: none;\n-webkit-user-select: none;\nvertical-align: middle;\nwhite-space: nowrap;\n}\n\n.button-50:focus {\ntext-decoration: none;\n}\n\n.button-50:hover {\ntext-decoration: none;\n}\n\n.button-50:active {\nbox-shadow: rgba(0, 0, 0, .125) 0 3px 5px inset;\noutline: 0;\n}\n\n.button-50:not([disabled]):active {\nbox-shadow: #fff 2px 2px 0 0, #000 2px 2px 0 1px;\ntransform: translate(2px, 2px);\n}\n\n@media (min-width: 768px) {\n.button-50 {\n  padding: 12px 50px;\n}\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
